import { Button } from './Button'
export default Button

export { getSkeletonType, skeletonButtonPadrao, skeletonButtonCircle, skeletonButtonSquare } from './buttons-skeleton';
export { Button, ButtonProps as BotaoProps } from './Button'
